<!-- auth-page wrapper -->
<div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
    <div class="bg-overlay"></div>
    <!-- auth-page content -->
    <div class="auth-page-content overflow-hidden pt-lg-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="card overflow-hidden">
              <div class="row g-0">
                <div class="col-lg-6">
                  <div class="p-lg-5 p-4 auth-one-bg h-100">
                    <div class="bg-overlay"></div>
                    <div class="position-relative h-100 d-flex flex-column">
                      <div class="mb-4">
                        <a routerLink="" class="d-block">
                          <img src="assets/images/weber-rescue-systems.png" alt="" height="45">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end col -->
  
                <div class="col-lg-6">
                  <div class="p-tb-5">
                    <div>
                      <h5 class="text-primary">{{ 'Reset Password' | translate }}</h5>
                      <p class="text-muted">{{ 'Enter your new password' | translate }}</p>
                    </div>
  
                    <div class="mt-4">
                      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
                        <!-- New Password Field -->
                        <div class="mb-3">
                          <label class="form-label" for="password">{{ 'New Password' | translate }}</label>
                          <div class="position-relative auth-pass-inputgroup mb-3">
                            <input
                              [type]="fieldTextType ? 'text' : 'password'"
                              id="password"
                              class="form-control pe-5"
                              formControlName="password"
                              placeholder="{{ 'Enter new password' | translate }}"
                              [ngClass]="{ 'is-invalid': resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched }"
                            />
                            <button
                              class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                              (click)="toggleFieldTextType()"
                            >
                              <i class="mdi align-middle" [ngClass]="{'mdi-eye-off-outline': !fieldTextType, 'mdi-eye-outline': fieldTextType}"></i>
                            </button>
                            <div *ngIf="resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched" class="invalid-feedback">
                              <div *ngIf="resetPasswordForm.get('password')?.errors?.['required']">
                                {{ 'Password is required' | translate }}
                              </div>
                              <div *ngIf="resetPasswordForm.get('password')?.errors?.['minlength']">
                                {{ 'Password must be at least 8 characters long' | translate }}
                              </div>
                            </div>
                          </div>
                        </div>
  
                        <!-- Confirm Password Field -->
                        <div class="mb-3">
                          <label class="form-label" for="passwordConfirmation">{{ 'Confirm Password' | translate }}</label>
                          <div class="position-relative auth-pass-inputgroup mb-3">
                            <input
                              [type]="fieldTextType ? 'text' : 'password'"
                              id="passwordConfirmation"
                              class="form-control pe-5"
                              formControlName="passwordConfirmation"
                              placeholder="{{ 'Confirm new password' | translate }}"
                              [ngClass]="{ 'is-invalid': resetPasswordForm.get('passwordConfirmation')?.invalid && resetPasswordForm.get('passwordConfirmation')?.touched }"
                            />
                            <button
                              class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                              (click)="toggleFieldTextType()"
                            >
                              <i class="mdi align-middle" [ngClass]="{'mdi-eye-off-outline': !fieldTextType, 'mdi-eye-outline': fieldTextType}"></i>
                            </button>
                            <div *ngIf="resetPasswordForm.get('passwordConfirmation')?.invalid && resetPasswordForm.get('passwordConfirmation')?.touched" class="invalid-feedback">
                              <div *ngIf="resetPasswordForm.get('passwordConfirmation')?.errors?.['required']">
                                {{ 'Password confirmation is required' | translate }}
                              </div>
                            </div>
                            <small class="form-text text-muted mt-1"><em>
                                {{'Password must be at least 8 characters long and contain an uppercase letter, a lowercase letter, a number, and a special character' | translate}}</em>
                            </small>
                          </div>
                        </div>

                        <!-- User Selection Field -->
                        <div class="mb-3" *ngIf="getUserDetails.length > 1">
                            <label for="userSelect" class="form-label">{{ 'Select User' | translate }}</label>
                            <select id="userSelect" formControlName="username" class="form-select">
                                <option value="" selected>{{ 'Select All Users' | translate }}</option>
                                <option *ngFor="let user of getUserDetails" [value]="user">{{ user }}</option>
                            </select>
                        </div>

                        <!-- Submit Button -->
                         <div class="mt-4">
                          <button class="btn btn-dark w-100" type="submit" [disabled]="resetPasswordForm.invalid || submitted">
                            {{ 'Reset Password' | translate }}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
              <!-- end row -->
            </div>
            <!-- end card -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
    <!-- end auth page content -->
  </div>
  <!-- end auth-page-wrapper -->